/**
 * This file is created manually
 * You can change the content
 *
 */

import H2 from './typography/H2'
export * from './typography/H2'
export default H2
